import React from "react";

import { observer } from "mobx-react";
import { Draggable } from "react-beautiful-dnd";

import { injectIntl, intlShape } from "react-intl";

import NoteBody from "./NoteBody";

const getItemStyle = (draggableStyle, isDragging) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  //padding: grid * 2,
  //margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  // background: isDragging ? '#FAFAFA' : 'transparent',
  border: isDragging ? "2px solid #0fa69a" : "",

  // webkitAnimationName: isDragging ? "scalex" : "",
  // webkitAnimationDuration: isDragging ? "2s" : "",
  // webkitAnimationTimingFunction: isDragging ? "ease-in-out" : "",

  // animationName: isDragging ? "scale" : "",
  // animationDuration: isDragging ? "0.3s" : "",
  // animationTimingFunction: isDragging ? "ease-in-out" : "",

  // styles we need to apply on draggables
  ...draggableStyle
});

@observer
class Note extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { note, intl, index } = this.props;

    const priority = note.priority;
    //console.log(priority);

    return (
      <Draggable
        key={note.id}
        draggableId={note.id}
        index={index}
        type={"LANE"}
      >
        {(provided, snapshot) => (
          <div>
            <li
              className={`note-container note-${priority}`}
              ref={provided.innerRef}
              {...provided.dragHandleProps}
              {...provided.draggableProps}
              style={getItemStyle(
                provided.draggableProps.style,
                snapshot.isDragging
              )}
            >
              <NoteBody note={note} />
            </li>

            {provided.placeholder}

            {/*<NoteModal note={note}/>*/}
          </div>
        )}
      </Draggable>
    );
  }

  componentWillMount() {
    this.handleDueDate();
    // todo: move this to the root component (Board.jsx) ///////////
    //this.updateWindowDimensions();
    // window.addEventListener('resize', this.updateWindowDimensions);
    ////////////////////////////////////////////////////////////////
  }

  componentWillUnmount() {
    // todo: move this to the root component (Board.jsx) ///////////
    // window.removeEventListener('resize', this.updateWindowDimensions);
    ////////////////////////////////////////////////////////////////
  }

  updateWindowDimensions = () => {
    // this.setState({width: window.innerWidth, height: window.innerHeight});
  };

  handleDueDate = () => {
    const { note, onPriorityChange } = this.props;

    if (note.finish_date) {
      const finishDate = new Date(note.finish_date);
      const oneDayAfter = new Date().getTime() + 1 * 24 * 60 * 60 * 1000;
      const threeDaysAfter = new Date().getTime() + 3 * 24 * 60 * 60 * 1000;

      if (finishDate < oneDayAfter) {
        if (note.priority !== "high_priority") {
          //console.log('1 day left: ', note.description);
          onPriorityChange.call(null, note, "high_priority");
          //note.priority = 'high_priority';
        }
      } else if (finishDate < threeDaysAfter) {
        if (note.priority !== "medium_priority") {
          //console.log('3 day left: ', note.description);
          onPriorityChange.call(null, note, "medium_priority");
          //note.priority = 'medium_priority';
        }
      }
    }
  };
}

Note.propTypes = {
  intl: intlShape.isRequired
};

export default injectIntl(Note);
